import React, { useEffect, useState } from "react";
import Header from "../home/header";
import UTILS from "../../utils/commons";
import { useLocation, useNavigate } from "react-router";
import Loading from "../home/Loading";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";

const IssueInventory = props => {
  let navigate = useNavigate();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

  const [ feedback, setFeedback ] = useState( "" );
  const [ products, setProducts ] = useState( [] );
  const [ filteredProducts, setFilteredProducts ] = useState( products );
  const [ managers, setManagers ] = useState( [] );
  const [ invoices, setInvoices ] = useState( [] );
  const [ inventory, setInventory ] = useState( [] );
  const [ selectedManager, setSelectedManager ] = useState();
  const [ selectedProduct, setSelectedProduct ] = useState();
  const [ selectedInvoice, setSelectedInvoice ] = useState();
  const [ qtty, setQtty ] = useState( 0 );
  const [ isLoading, setIsLoading ] = useState( false );
  const [ showSubmit, setShowSubmit ] = useState( true );
  const labelClass = "mb-1 block text-sm font-medium text-gray-700";
  const controlClass = "form-control h-11 rounded-md border-gray-300";


  const loadData = async () => {
    const [
      products,
      managers,
      inventory,
    ] = await Promise.all( [
      apiClient.get( "products/list" ),
      apiClient.get( "profiles/list" ),
      apiClient.get( "inventory" )
    ] );
    if ( products.status === 200 ) {
      setProducts( products.data );
    }
    if ( managers.status === 200 ) {
      setManagers( managers.data );
    }
    if ( inventory.status === 200 ) {
      const invs = inventory.data.map( inv => inv.invoiceNumber );
      setInventory( inventory.data );
      const uniqueInvs = [ ...new Set( invs ) ];
      setInvoices( uniqueInvs );
    }
  }

  const handleSubmit = async ( e ) => {
    e.preventDefault();
    if ( !selectedManager || !selectedProduct || !selectedInvoice || !qtty ) {
      setFeedback( "Please fill in all required fields." );
      return;
    }
    if ( parseInt( qtty ) <= 0 ) {
      setFeedback( "Quantity must be greater than zero." );
      return;
    }
    // setIsLoading( true );
    // setShowSubmit( false );
    let formData = {
      profileId: selectedManager,
      productId: selectedProduct,
      invoiceNumber: selectedInvoice,
      quantity: parseInt( qtty ),
    };
    console.log( "🚀 ~ handleSubmit ~ formData:", formData )
    try {
      const response = await apiClient.post( "issues", formData );
      if ( response.status === 201 || response.status === 200 ) {
        setIsLoading( false );
        navigate( "/inventory", { replace: true } );
      } else {
        const errorData = await response.data;
        setFeedback( errorData.message || "Failed to issue stock" );
        setIsLoading( false );
        setShowSubmit( true );
      }
    } catch ( e ) {
      console.log( e );
      setIsLoading( false );
      setShowSubmit( true );
      setFeedback( e instanceof AxiosError ? e.response?.data.msg : "Oops! Something went wrong." );
    }
  }
  const handleManagerChange = ( e ) => {
    setSelectedManager( e.target.value );
  }

  const handleProductChange = ( e ) => {
    let productId = e.target.value.trim();
    setSelectedProduct( productId );
    const inv = inventory.filter( i => i.product.id.toString() === productId );
    if ( inv.length > 0 ) {
      setQtty( inv[ 0 ].availableQuantity );
    } else {
      setQtty( 0 );
    }
  }

  const handleInvoiceChange = ( e ) => {
    setSelectedInvoice( e.target.value );
    const productsInInvoice = inventory.filter( i => i.invoiceNumber === e.target.value && i.availableQuantity > 0 ).map( i => i.product );
    setFilteredProducts( productsInInvoice );
  }

  const handleQttyChange = ( e ) => {
    setQtty( e.target.value );
  }

  useEffect( () => {
    loadData();
  }, [] )
  return ( <>
    <Header auth={loginState} />
    <section className="flex justify-start items-start">
      <div className="container mx-auto">
        <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-6 shadow-sm">
          {feedback ? <div className="w-full rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-center text-blue-700">{String( feedback?.message || feedback )}</div> : null}
          <div className="mb-4">
            <p className="text-sm uppercase tracking-wide text-gray-500">Stock</p>
            <p className="text-2xl font-semibold text-gray-800">Issue Inventory</p>
          </div>
          <form id="issue_form" onSubmit={handleSubmit}
            className="w-full md:w-11/12 lg:w-10/12 mx-auto"
            method="post"
          >
            <div className="rounded-lg border border-gray-200 bg-white p-4 md:p-5">
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-3">Assignment</p>
              <div className="row">
                <div className="form-group my-2 col-md-6 col-lg-6 col-sm-10">
                  <label className={labelClass} htmlFor="manager">Select Manager</label>
                  <select onChange={( e ) => handleManagerChange( e )} value={selectedManager}
                    required
                    type="text"
                    className={controlClass}
                    id="manager"
                    name="manager">
                    <option value={null}>--select--</option>
                    {managers.map( ( r => {
                      return <option key={r.id} value={r.id}>{r.auth.firstName + " " + r.auth.lastName}</option>
                    } ) )}
                  </select>
                </div>
                <div className="form-group my-2 col-md-6 col-lg-6 col-sm-10">
                  <label className={labelClass} htmlFor="invoice">Select Invoice Number</label>
                  <select required
                    className={controlClass} onChange={( e ) => handleInvoiceChange( e )} value={selectedInvoice}
                    id="invoice"
                    name="invoice">
                    <option>--select--</option>
                    {invoices.map( inv => {
                      return <option key={UTILS.randomKey()}>{inv}</option>
                    } )}
                  </select>
                </div>
              </div>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white p-4 md:p-5 mt-4">
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-3">Item and Quantity</p>
              <div className="row">
                <div className="form-group my-2 col-md-6 col-lg-6 col-sm-10">
                  <label className={labelClass} htmlFor="product">Select Product</label>
                  <select required
                    disabled={filteredProducts.length === 0} value={selectedProduct} onChange={( e ) => handleProductChange( e )}
                    className={controlClass}
                    id="product"
                    name="product">
                    <option>--select--</option>
                    {filteredProducts.map( p => {
                      return <option key={p.id} value={p.id}>{p.productName + " (" + p.packSize + ")"}</option>
                    } )}
                  </select>
                </div>
                <div className="form-group my-2 col-md-6 col-lg-6 col-sm-10">
                  <label className={labelClass} htmlFor="quantity">Quantity</label>
                  <input required value={qtty} onChange={( e ) => handleQttyChange( e )} max={qtty}
                    type="number"
                    className={controlClass}
                    id="quantity"
                    name="quantity"
                    placeholder="Number of cartons"
                  />
                </div>

              </div>
            </div>

            <div className="form-group my-2 row mt-4">
              {showSubmit ?
                <div className="my-2 md:w-6/12 w-10/12">
                  {isLoading ? <Loading className="mx-auto mt-16" /> :
                    <input
                      type="submit"
                      className="form-control h-11 rounded-md bg-success md:w-5/12 w-10/12 text-white font-semibold"
                      id="btnSubmit"
                      name="btnSubmit"
                      value="SUBMIT"
                    />}
                </div> : null}
              <div className="my-2 md:w-6/12 w-10/12">
                <input onClick={() => { navigate( -1 ) }}
                  type="button"
                  className="form-control h-11 rounded-md md:w-5/12 w-10/12"
                  value="Cancel"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </> )

}
export default IssueInventory;